/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  InputLineController,
  ToggleSwitchController,
  SelectController,
  RangeController,
  ChoiceBoxController,
  CustomSortController,
} from '../../../controllers/Base';

const GeneralControllers = ({
  handle,
  config,
  data,
  extend,
  setExtend,
}) => (
  <>
    <ControllersGroup
      title="Opções Gerais"
      id="general"
      extend={extend}
      setExtend={setExtend}
      sizeIncrease={config?.SortValuesControl === 'Customizado' ? data?.index?.length : 0}
    >
      <SelectController
        label="Ordenar campos"
        handle={handle}
        kWord="SortValuesControl"
        options={[
          { label: 'Automático', value: 'Não ordenado', id: 'nao-ordenado' },
          { label: 'Alfabética A-Z', value: 'Alfabética A-Z', id: 'alfabetica-a-z' },
          { label: 'Alfabética Z-A', value: 'Alfabética Z-A', id: 'alfabetica-z-a' },
          { label: 'Valor Crescente', value: 'Valor Crescente', id: 'valor-crescente' },
          { label: 'Valor Decrescente', value: 'Valor Decrescente', id: 'valor-decrescente' },
          { label: 'Customizado', value: 'Customizado', id: 'customizado' },
        ]}
        configValue={config?.SortValuesControl}
        fullWidth
      />
      {config?.SortValuesControl === 'Customizado' && (
        <CustomSortController
          handle={handle}
          kWord="CustomSortControlUpt"
          oldOrder={data?.index || []}
          newOrder={config?.CustomSortControl?.kpiCategories || []}
          removeTotal
        />
      )}
      <RangeController
        label="Ângulo inicial"
        handle={handle}
        kWord="StartAngleControl"
        configValue={config?.StartAngleControl}
        min={-360}
        max={360}
        fullWidth
      />
      <RangeController
        label="Ângulo final"
        handle={handle}
        kWord="EndAngleControl"
        configValue={config?.EndAngleControl}
        min={-360}
        max={360}
        fullWidth
      />
      <RangeController
        label="Raio Interno"
        handle={handle}
        kWord="InnerRadiusControl"
        configValue={config?.InnerRadiusControl?.value}
        min={0}
        max={0.9}
        step={0.1}
        precision={1}
        fullWidth
      />
      <RangeController
        label="Margem Superior"
        handle={handle}
        kWord="MarginTop"
        configValue={config?.Margin?.top}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Inferior"
        handle={handle}
        kWord="MarginBottom"
        configValue={config?.Margin?.bottom}
        min={-250}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Esquerda"
        handle={handle}
        kWord="MarginLeft"
        configValue={config?.Margin?.left}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Direita"
        handle={handle}
        kWord="MarginRight"
        configValue={config?.Margin?.right}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <ToggleSwitchController
        label="Valor máximo"
        handle={handle}
        kWord="MaxValueControl2"
        configValue={config?.MaxValueControl?.checked}
        firstOption="Automático"
        secondOption="Manual"
        secondColor="secondary"
      />
      <InputLineController
        isNumber
        precision={2}
        label=""
        handle={handle}
        kWord="MaxValue"
        configValue={config?.MaxValueControl?.value}
        disabled={config?.MaxValueControl?.checked}
      />
      <ToggleSwitchController
        label="Métrica afeta valor máximo"
        handle={handle}
        kWord="MetricMaxValue"
        configValue={config?.MetricMaxValue}
        fullWidth
        disabled={!config?.MaxValueControl?.checked}
      />
      <ChoiceBoxController
        label="Dados primários"
        handle={handle}
        kWord="DataFormat"
        configValue={config?.DataFormat}
        options={[
          { value: 'absolute', label: 'Absoluto', id: 'absolute' },
          { value: 'percentual', label: 'Percentual', id: 'percentual' },
        ]}
        fullWidth
      />
      {config?.DataFormat === 'absolute' && (
        <ChoiceBoxController
          label="Formato absoluto"
          handle={handle}
          kWord="DataAbsoluteFormat"
          configValue={config?.DataAbsoluteFormat}
          options={[
            { label: 'Número', value: 'number', id: 'number' },
            { label: 'Duração', value: 'duration', id: 'duration' },
          ]}
          fullWidth
        />
      )}

      <hr style={{ width: '100%', color: 'lightgray', opacity: '0.2' }} />

      <ChoiceBoxController
        label="Dados secundários"
        handle={handle}
        kWord="DataFormatAlt"
        configValue={config?.DataFormatAlt}
        options={[
          { value: 'none', label: 'Nenhum', id: 'none' },
          { value: 'absolute', label: 'Absoluto', id: 'absolute' },
          { value: 'percentual', label: 'Percentual', id: 'percentual' },
        ]}
        fullWidth
      />
      {config?.DataFormatAlt === 'absolute' && (
        <ChoiceBoxController
          label="Formato absoluto"
          handle={handle}
          kWord="DataAbsoluteFormatAlt"
          configValue={config?.DataAbsoluteFormatAlt}
          options={[
            { label: 'Número', value: 'number', id: 'number' },
            { label: 'Duração', value: 'duration', id: 'duration' },
          ]}
          fullWidth
        />
      )}
      {(
        (config?.DataFormat === 'absolute' && config?.DataAbsoluteFormat === 'duration')
        || (config?.DataFormatAlt === 'absolute' && config?.DataAbsoluteFormatAlt === 'duration')
      ) && (
        <>
          <hr style={{ width: '100%', color: 'lightgray', opacity: '0.2' }} />
          <ChoiceBoxController
            label="Unidade original"
            handle={handle}
            kWord="DurationUnit"
            configValue={config?.DurationUnit}
            options={[
              { label: 'Dias', value: 'days', id: 'days' },
              { label: 'Horas', value: 'hours', id: 'hours' },
              { label: 'Minutos', value: 'minutes', id: 'minutes' },
              { label: 'Segundos', value: 'seconds', id: 'seconds' },
            ]}
            fullWidth
          />
        </>
      )}
    </ControllersGroup>
  </>
);

GeneralControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
};

export default GeneralControllers;
